import { defineStyleConfig, } from '@chakra-ui/react';
const baseStyle = {
    fontVariantNumeric: 'tabular-nums',
};
export const textConfig = defineStyleConfig({
    baseStyle,
});
//# sourceMappingURL=text-theme.js.map